import Services from '@/services/index';
import VT, { VTN } from '@/store/types';
import { Backend } from '@/_axios';

export default {
  [VT.LOGIN]: ({
    commit, dispatch, state, getters
  }, data) => {
    return new Promise((resolve, reject) => {
      const service = data.oauth ? Services.auth.oAuthLogin : Services.auth.login;
      // console.log('VT.LOGIN');
      // eslint-disable-next-line no-shadow
      service(data).then(({ data }) => {
        commit(VT.SET_AUTH_TOKEN, data.access_token);
        Backend.defaults.headers['Authorization'] = `Bearer ${data.access_token}`;
        commit(VT.SET_AUTH_INFO, data);
        if (data.refresh_token) {
          commit(VT.SET_REFRESH_TOKEN, data.refresh_token);
        }
        // set first user project as default
        if (getters.projects.length) {
          let projectId = getters.projects[0].id;
          const validProjectIds = getters.projects.map((p) => p.id);
          if (state.session && state.session.activeProjectId && validProjectIds.includes(state.session.activeProjectId)) {
            projectId = state.session.activeProjectId;
          }
          commit(VT.SET_ACTIVE_PROJECT, projectId);
          dispatch(VTN.PROJECT_LOAD, projectId, { root: true });
        }
        resolve();
      }, () => {
        reject();
      });
    });
  },
  [VT.LOAD_USER_INFO]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      Services.auth.userWithProject().then(({ data }) => {
        commit(VT.SET_AUTH_INFO, data);
        resolve();
      }).catch((errResponse) => {
        // console.log(errResponse);
        reject();
      });
    });
  },
  [VT.LOGOUT]: ({ commit }) => {
    return new Promise((resolve) => {
      commit(VT.SET_AUTH_TOKEN, null);
      commit(VT.SET_REFRESH_TOKEN, null);
      resolve();
    });
  },
  [VT.UPDATE_AUTH_TOKEN]: ({ commit }, token) => {
    return new Promise((resolve) => {
      commit(VT.SET_AUTH_TOKEN, token);
      Backend.defaults.headers['Authorization'] = `Bearer ${token}`;
      resolve();
    });
  },

  [VT.REFRESH_AUTH_TOKEN]: ({ commit, getters }) => {
    if (!getters['refreshTokenValid'](10)) return Promise.reject();
    return new Promise((resolve) => {
      Services.auth.refresh(getters['refreshToken']).then(({ data }) => {
        commit(VT.SET_AUTH_TOKEN, data.access_token);
        Backend.defaults.headers['Authorization'] = `Bearer ${data.access_token}`;
        resolve(data.access_token);
      });
    });
  },

  [VT.SET_ACTIVE_PROJECT]: ({ commit, dispatch, state }, projectId) => {
    commit(VT.SET_ACTIVE_PROJECT, projectId);
    dispatch(VTN.PROJECT_LOAD, projectId, { root: true });
    if (projectId) Services.auth.persistSession({ ...state.session, activeProjectId: projectId });
    return Promise.resolve();
  },

  [VT.SET_SESSION_VAR]: ({ commit, dispatch, state }, args) => {
    commit(VT.SET_SESSION_VAR, args);
    Services.auth.persistSession({ ...state.session, activeProjectId: state.activeProjectId }); // we cant get any response as this is debounced
    return Promise.resolve();
    // dispatch(VTN.PROJECT_LOAD, projectId, { root: true });
  },

  // [VT.LOGIN_OAUTH]: ({ commit }, data) => {
  //   // commit(VT.SET_ACTIVE_PROJECT, projectId);
  //   return Promise.resolve();
  // },
};
